const isFeatureEnabled = (flags, flagKey) => flags?.[flagKey]?.variation_key === 'on';
export default isFeatureEnabled;
